import { Loader2 } from 'lucide-react';
import { cn } from '@lib/utils';

const AppleIcon = () => (
  // <svg viewBox="3 1 18 22" width="24" height="24" aria-hidden="true" fill="currentColor">
  //   <path d="M16.365 12.83c.016 1.65 1.459 2.2 1.475 2.208-.012.038-.23.79-.756 1.564-.456.669-.93 1.335-1.675 1.348-.733.014-.968-.436-1.808-.436-.84 0-1.101.422-1.795.45-.72.027-1.268-.72-1.728-1.387-.939-1.358-1.656-3.835-.693-5.511.479-.832 1.336-1.358 2.267-1.372.707-.013 1.374.477 1.808.477.434 0 1.247-.59 2.102-.504.358.015 1.362.145 2.006 1.087-.052.033-1.198.697-1.203 2.076ZM14.97 8.248c.382-.463.64-1.107.57-1.748-.55.022-1.216.366-1.61.83-.355.411-.666 1.067-.58 1.694.613.047 1.238-.311 1.62-.776Z" />
  // </svg>
  <svg
    fill="#000000"
    width="24px"
    height="24px"
    viewBox="-3.5 -2 24 24"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin"
  >
    <path d="M13.623 10.627c-.025-2.533 2.066-3.748 2.159-3.808-1.175-1.72-3.005-1.955-3.657-1.982-1.557-.158-3.039.917-3.83.917-.788 0-2.008-.894-3.3-.87C3.299 4.909 1.734 5.87.86 7.39c-1.764 3.06-.452 7.595 1.267 10.077.84 1.215 1.842 2.58 3.157 2.53 1.266-.05 1.745-.819 3.276-.819 1.531 0 1.962.82 3.302.795 1.363-.026 2.226-1.239 3.06-2.457.965-1.41 1.362-2.775 1.386-2.845-.03-.013-2.658-1.02-2.684-4.045zm-2.518-7.433c.698-.847 1.169-2.022 1.04-3.194C11.14.04 9.921.67 9.2 1.515c-.647.75-1.214 1.945-1.062 3.094 1.122.088 2.268-.57 2.967-1.415z" />
  </svg>
);

interface AppleSignInButtonProps {
  text?: string;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
}

export function AppleSignInButton({
  text = 'Sign in with Apple',
  onClick,
  disabled,
  isLoading,
  className,
}: AppleSignInButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled || isLoading}
      onClick={onClick}
      className={cn(
        'inline-flex w-full items-center justify-center gap-3 rounded-md border px-4 py-2 text-sm font-medium',
        'transition-all duration-150',
        'border-border bg-background text-foreground shadow-xs',
        'hover:bg-accent hover:text-accent-foreground',
        'active:bg-accent/80',
        'focus-visible:outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
    >
      {isLoading ? <Loader2 className="size-5 animate-spin" /> : <AppleIcon />}
      <span>{text}</span>
    </button>
  );
}
